import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SwipeableViews from "react-swipeable-views";
import {
  setLayouts,
  addLayout,
  changeSelected,
  updateLayouts,
  setLayoutType,
} from "./redux/actions/layoutActions";
import { withRouter } from "react-router";
import CardLayout from "./CardLayout";
import { withStyles, createMuiTheme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { editTheme } from "./redux/actions/themeActions";
import axios from "./AxiosClient";
import PubSub from "pubsub-js";
import {
  LAYOUT,
  LAYOUT_ADD,
  LAYOUT_DELETE,
  LAYOUT_UPDATE,
} from "./utils/Topics";

const styles = (theme) => ({
  modalAppBar: {
    position: "relative",
  },
  modalToolbar: {
    paddingLeft: 0,
  },
  docViewer: {
    display: "flex",
  },
  dialogContainer: {
    display: "flex",
    flexDirection: "column",
    // overflowY: "hidden",
    // overflowX: 'hidden'
  },
  srOnly: {
    position: "absolute",
    left: "-10000px",
    width: "1px",
    height: "1px",
    overflow: "hidden",
  },
});

export class UserLayouts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedWithLag: 0,
      layoutsWithFullscreen: new Set(),
      fullscreenDialogOpen: false,
    };
  }
  static propTypes = {
    userLayout: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    this.loadLayout();
    this.token = PubSub.subscribe(LAYOUT, this.subscriber);
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this.token);
  }

  subscriber = (msg, data) => {
    switch (msg) {
      case LAYOUT_ADD:
        if (
          (this.props.userLayout && data.layout.layoutType === "user") ||
          (!this.props.userLayout && data.layout.layoutType === "team")
        ) {
          this.props.addLayout(data.layout);
        }
        break;
      case LAYOUT_UPDATE:
        let layouts = this.props.layouts.map((item) => {
          if (item.id === data.layoutId) {
            data.layout.gridLayout = JSON.parse(data.layout.gridLayout);
            return { ...item, ...data.layout };
          }
          return item;
        });
        this.props.updateLayouts(layouts);
        break;
      default:
        break;
    }
  };

  componentDidUpdate(prevProps) {

    if (
      this.props.currentUser !== prevProps.currentUser &&
      Object.keys(this.props.currentUser).length > 0 &&
      this.props.selected === 0 
    ) {
      this.loadLayout();
    }
    if ((this.props.userLayout !== prevProps.userLayout) && this.props.selected === 0 ) {
      this.loadLayout();
    }
    if ((this.props.selectedTeam !== prevProps.selectedTeam)) {
      this.loadLayout();
    }

    if (this.props.selected !== prevProps.selected) {
        this.cardLayoutLoaded()
    }
    
    // if (this.props.firstLoad !== prevProps.firstLoad) {
    //   if (this.props.match.params.id) {
    //     //eslint-disable-next-line eqeqeq
    //     var tabIndex = this.props.layouts.findIndex(
    //       (l) => l.id === parseInt(this.props.match.params.id)
    //     ); // compare string to number, so == is correct
    //     if (tabIndex === -1) {
    //       tabIndex = 0;
    //     }
    //     this.props.changeSelected(tabIndex);
    //   } else {
    //     this.cardLayoutLoaded();
    //   }
    // }
  }

  render() {
    let selected = this.props.layouts.filter((l) => l.id === this.props.selected).length > 0 
      ? this.props.layouts.findIndex((l) => l.id === this.props.selected)
      : 0
    return (
      <div style={{ height: "100%" }} id="layout-container">
        <Typography component="h2" className={this.props.classes.srOnly}>
          Layout
        </Typography>
        <SwipeableViews
          index={selected}
          style={{ height: "100%" }}
          disabled={true}
          disableLazyLoading={false}
          slideClassName="swipeable-slide"
          slideStyle={{
            overflowX: "hidden",
            overflowY: this.layoutIsFullscreen() ? "hidden" : "auto",
          }}
        >
          {this.props.layouts.map((element, idx) => {
            return (
              <CardLayout
                key={element.id}
                loaded={element.loaded}
                layout={element}
                url={element.uri}
                layoutId={element.id}
                title={element.title}
                themeId={element.themeId}
                onFullscreen={this.layoutOnFullscreen}
                gridLayout={element.gridLayout}
                selected={this.props.selected === element.id || this.props.selected === 0 && idx === 0}
              />
            );
          })}
        </SwipeableViews>
      </div>
    );
  }

  layoutOnFullscreen = (fullscreen, layoutId) => {
    if (fullscreen) {
      this.setState({
        layoutsWithFullscreen: this.state.layoutsWithFullscreen.add(layoutId),
      });
    } else {
      let clone = new Set(this.state.layoutsWithFullscreen);
      clone.delete(layoutId);
      this.setState({ layoutsWithFullscreen: clone });
    }
  };

  layoutIsFullscreen = () => {
    var layout = this.props.selected === 0 
      ? this.props.layouts[parseInt(this.props.selected)]
      : this.props.layouts.filter(l => l.id === this.props.selected)[0]
    if (!layout) return false;
    return this.state.layoutsWithFullscreen.has(layout.layoutId);
  };

  cardLayoutLoaded = () => {
    var layout = this.props.selected === 0 
      ? this.props.layouts[parseInt(this.props.selected)]
      : this.props.layouts.filter(l => l.id === this.props.selected)[0]
    if (this.props.layouts && layout) {
      var layoutsCopy = [...this.props.layouts];
      let layoutIdx = this.props.layouts.findIndex((el) => el.id === layout.id)
      if (layoutIdx > -1) {
        layoutsCopy[layoutIdx].loaded = true;
        this.props.updateLayouts(layoutsCopy);
      }
      let palette = {};
      if (layout.primaryColour && layout.secondaryColour) {
        palette = {
          primary: {
            main: layout.primaryColour,
          },
          secondary: {
            main: layout.secondaryColour,
          },
        };
      }
      let theme = createMuiTheme({
        typography: {
          useNextVariants: true,
        },
        palette,
      });
      this.props.editTheme(theme);
      localStorage.setItem("palette", JSON.stringify(palette));
    }
  };
  loadLayoutForId = (layoutId) => {
    //we have been passed an id and we need to figure out what it is and set the layoutType and selectedTeam as needed
    let url = `/portalLayout/${layoutId}`
    axios.get(url, { withCredentials: true }).then((res) => {
      let selectedTeam = res.data.teamPortals.length > 0 ? res.data.teamPortals[0].teamId : null
      if (selectedTeam !== null && this.props.layoutType !== "team") {
        this.props.setLayoutType("team")
        this.props.setSelectedTeam(selectedTeam)
      } else {
        this.props.setLayoutType("user")
      }
      this.getLayouts()
    })
  }
  loadLayout = () => {
    if (this.props.selected !== 0 && this.props.layouts.filter(l => l.id === this.props.selected).length === 0) {
      this.loadLayoutForId(this.props.selected)
    } else {
      this.getLayouts()
    }

  };
  getLayouts = () => {
      let url = `/portalLayout/?team=${!this.props.userLayout}`;
      if (this.props.selectedTeam && !this.props.userLayout) {
        url = url + `&teamId=${this.props.selectedTeam}`;
      }
      axios.get(url, { withCredentials: true }).then((res) => {
        var layouts = res.data;
        layouts.forEach((item, pos) => {
          // item.loaded = pos === this.state.selectedWithLag;
          item.loaded = false;
          item.selected = pos === 0;
          if (!item.gridLayout) item.gridLayout = '{"lg":[]}';
          item.gridLayout = JSON.parse(item.gridLayout);
        });
        this.props.setLayouts(layouts);
        this.cardLayoutLoaded();
      });
  }

  _addLayout(e) {
    this.addLayout(e.detail);
  }
}

const mapStateToProps = (state) => ({
  layouts: state.layout.layouts,
  selected: state.layout.selectedTab,
  firstLoad: state.layout.firstLoad,
  currentUser: state.user.currentUser,
});

const mapDispatchToProps = {
  setLayouts,
  addLayout,
  changeSelected,
  updateLayouts,
  editTheme,
  setLayoutType,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(UserLayouts))
);
